import React, { Component } from "react";

class BlankLayout extends Component {
  onChangeTab(route) {
    this.setState(prevState => {
      return { ...prevState, route };
    });
  }
  render() {
    return (
      <div className="main">
        <div className="">{this.props.children}</div>
      </div>
    );
  }
}

export default BlankLayout;



// WEBPACK FOOTER //
// ./src/util/Layouts/BlankLayout/index.js